import StockFollowUp from './StockFollowUp'

export default StockFollowUp
